/**
 * Identity function that just returns the original route props provided by React Router
 * without any modifications.
 * @param {object} routeProps - Route props provided by React Router
 * @returns {object}          - The same route props without any transformation
 */
export const identityParseRoute = ({ location, match }) => ({ location, match });
